











// vendor
import { defineComponent, computed, ref, watch } from "@vue/composition-api";
// project
import { ViewAssetHistory } from "@/components.assets/view-asset-history";
// local
import * as Utils from "./utils";

export default defineComponent({

	emits:[],
	props:{
	},
	components:{
		ViewAssetHistory,
	},
	setup(props, context){
		
		const currentVersion = ref<string>(Utils.getQueryValue("version", context));

		const assetId = computed(() => {
			return context.root.$route.params["assetId"];
		});

		watch(currentVersion, (v, old) => {
			if(context.root.$route.query["version"] !== currentVersion.value){
				Utils.setQueryValue("version", currentVersion.value, context);
			}
		});

		watch(() => context.root.$route.query["version"], () => {
			if(context.root.$route.query["version"] !== currentVersion.value){
				currentVersion.value = Utils.getQueryValue("version", context);
			}
		});

		return {
			assetId,
			currentVersion,
		};
	}
});

